import {getPanels} from '../../../../../src/store/panels/panelsSelectors';
import {KnowledgeBasePanelId, PanelTypesEnum} from '../../../../../src/store/panels/panelStateBase';
import {createSelector} from '../../../../../srcCommon/helpers/reselectHelpers';
import {KnowledgeBaseParametricSelector} from '../knowledgeBaseReselectHelpers';
import {KnowledgeBasePanelState} from './knowledgeBasePanelState';

/*
 * Panel Selectors.
 */

export interface KnowledgeBasePanelProps {
  panelId: KnowledgeBasePanelId;
}

export type KnowledgeBasePanelIdSelector<P> = KnowledgeBaseParametricSelector<P, KnowledgeBasePanelId>;

function getKnowledgeBasePanelId(_state: unknown, props: KnowledgeBasePanelProps) {
  return props.panelId;
}

type KnowledgeBasePanelSelector<P> = KnowledgeBaseParametricSelector<P, KnowledgeBasePanelState>;

export function makeGetKnowledgeBasePanel(): KnowledgeBasePanelSelector<KnowledgeBasePanelProps>;
export function makeGetKnowledgeBasePanel<P>(
  getPanelId: KnowledgeBasePanelIdSelector<P>,
): KnowledgeBasePanelSelector<P>;
export function makeGetKnowledgeBasePanel(
  getPanelId: KnowledgeBasePanelIdSelector<any> = getKnowledgeBasePanelId,
) {
  return createSelector([getPanels, getPanelId], (panels, panelId) => {
    const panel = panels[panelId];

    if (!panel || panel.type !== PanelTypesEnum.KNOWLEDGE_BASE) {
      throw new Error('Knowledge base panel not found.');
    }

    return panel;
  });
}

export function makeGetKnowledgeBaseParameters() {
  return createSelector([makeGetKnowledgeBasePanel()], ({parameters}) => parameters);
}

export function makeGetKnowledgeBasePath() {
  return createSelector([makeGetKnowledgeBasePanel()], ({parameters}) => parameters.location.pathname);
}
